import React, { PureComponent } from 'react'

import bemClass from './../../utils/bemClass'

import './Dummy.css'

import dummy from './../../dummies/layout_web_KARROT–KK_1.png'

const cn = bemClass('Dummy')

class Dummy extends PureComponent {
    render() {
        if (!window || !window.location.href.includes('dummy=on')) {
            return null

        }
        return (
            <div className={cn()}>
                <img src={dummy} className={cn('image')} alt="dummy for development" />
            </div>
        )
    }
}

Dummy.propTypes = {

}

export default Dummy


// WEBPACK FOOTER //
// ./src/components/Dummy/Dummy.jsx